import { DocumentData } from "@angular/fire/firestore";
import { MenuTipDollarSettings } from "./menu.dollar.model";

export class MenuTipDollarSettingsBuilder {
  private _minimum: number;
  private _one: number;
  private _two: number;
  private _three: number;
  constructor() {
    this.default();
  }

  forFiveToTen(): MenuTipDollarSettingsBuilder {
    this._one = 1;
    this._two = 2;
    this._three = 3;
    return this;
  }

  public get minimum(): number {
    return this._minimum;
  }

  public set minimum(dollar: number) {
    this._minimum = dollar;
  }

  public get one(): number {
    return this._one;
  }

  public set one(dollar: number) {
    this._one = dollar;
  }

  public get two(): number {
    return this._two;
  }

  public set two(dollar: number) {
    this._two = dollar;
  }

  public get three(): number {
    return this._three;
  }

  public set three(dollar: number) {
    this._three = dollar;
  }

  private default(): void {
    this._minimum = 0.5;
    this._one = 1.0;
    this._two = 2.0;
    this._three = 3.0;
  }

  public load(data: DocumentData): MenuTipDollarSettingsBuilder {
    this._minimum = data.minimum ? data.minimum / 100 : 0;
    this._one = data.one ? data.one / 100 : null;
    this._two = data.two ? data.two / 100 : null;
    this._three = data.three ? data.three / 100 : null;
    return this;
  }

  public edit(settings: MenuTipDollarSettings): MenuTipDollarSettingsBuilder {
    this._minimum = settings.minimum;
    this._one = settings.one;
    this._two = settings.two;
    this._three = settings.three;
    return this;
  }
  public build(): MenuTipDollarSettings {
    return new MenuTipDollarSettings(this);
  }

  public toJSON = () => ({
    minimum: this._minimum ? this._minimum * 100 : 0,
    one: this._one ? this._one * 100 : null,
    two: this._two ? this._two * 100 : null,
    three: this._three ? this._three * 100 : null
  });
}
